import { lazyWithChunkReload as lazy } from "./lazyWithChunkReload";
import ShiftsActive from "../views/pages/legacy-shifts/list/active";
import ShiftsConfirmed from "../views/pages/legacy-shifts/list/confirmed";
import ShiftsArchived from "../views/pages/legacy-shifts/list/archived";
const Login = lazy(() => import("../views/login/login"));
const Forget = lazy(() => import("../views/login/forget"));
const Reset = lazy(() => import("../views/login/reset"));
const AcceptInvite = lazy(() => import("../views/login/accept-invite"));
const DeleteApp = lazy(() => import("../views/login/deleteApp"));
const Index = lazy(() => import("../views/pages/index"));
const HomePage = lazy(() => import("../views/home/index"));
const Yet = lazy(() => import("../views/yet"));
const PrivacyPolicyRedirect = lazy(async () => {
  const module = await import("../components/common/legalRedirects");
  return { default: module.PrivacyPolicyRedirect };
});
const TermsOfUseRedirect = lazy(async () => {
  const module = await import("../components/common/legalRedirects");
  return { default: module.TermsOfUseRedirect };
});
const AccessIndex = lazy(() => import("../views/assess/index"));
const Complete = lazy(() => import("../views/complete/complete"));
const Test = lazy(() => import("../views/test/index"));
// pages which need authority
const LegacyShifts = lazy(() => import("../views/pages/legacy-shifts/index"));

// const ShiftsActive = lazy(() => import("../views/pages/shifts/list/active"))
// const ShiftsConfirmed = lazy(() => import("../views/pages/shifts/list/confirmed"))
// const ShiftsArchived = lazy(() => import("../views/pages/shifts/list/archived"))

const ShiftCreate = lazy(
  () => import("../views/pages/create/create-new-layout"),
);
const DateActive = lazy(() => import("../views/pages/shiftDetail/date"));
const Applicant = lazy(() => import("../views/pages/shiftDetail/applicant"));
const Doctor = lazy(
  () => import("../views/pages/shiftDetail/doctor-profile-v2"),
);
// const Doctor = lazy(() => import("../views/pages/shiftDetail/doctor"));
const Account = lazy(() => import("../views/pages/account/index"));
const AccountEdit = lazy(() => import("../views/pages/account/edit"));
const Vault = lazy(() => import("../views/pages/vault/index"));
const Bank = lazy(() => import("../views/pages/bank/index"));
const InternalDoctorProfile = lazy(
  () => import("../views/pages/bank/InternalDoctorProfile"),
);
const Social = lazy(() => import("../views/social/index"));
const SocialDoctorProfile = lazy(
  () => import("../views/social/SocialDoctorProfile"),
);
const ApplicantModalRoute = lazy(
  () => import("../views/applicant/ApplicantModalRoute"),
);
const Notifications = lazy(() => import("../views/notifications/index"));
const CalendarPage = lazy(() => import("../views/calendar/index"));
const DashboardPage = lazy(() => import("../views/dashboard/index"));
const OverviewPage = lazy(() => import("../views/dashboard/index"));
const RosterPage = lazy(() => import("../views/roster/index"));
const StaffPage = lazy(() => import("../views/staff/index"));
const OrganisationPage = lazy(
  () => import("../views/organisation/index"),
);
const DepartmentsPage = lazy(() => import("../views/departments/redirect"));
const FinancePage = lazy(() => import("../views/finance/redirect"));
const LeavePage = lazy(() => import("../views/leave/index"));
const TimePage = lazy(() => import("../views/time/index"));
const ReportsPage = lazy(() => import("../views/reports/index"));
const PayrollPage = lazy(() => import("../views/payroll/index"));
const HrPage = lazy(() => import("../views/hr/index"));
const PermanentPage = lazy(() => import("../views/permanent/index"));
const ShiftsV2 = lazy(() => import("../views/hire/index"));
const MessagesPage = lazy(
  (() => import("../views/messages/index").then((module) => ({ default: module.default as any }))) as any,
);
const PreCredentialPage = lazy(() => import("../views/precredential/index"));

export interface RouteConfigDeclaration {
  /**
   * 当前路由路径
   */
  path: string;
  /**
   * 当前路由名称
   */
  name?: string;
  /**
   * 是否严格匹配路由
   */
  exact?: boolean;
  /**
   * 是否需要路由鉴权
   */
  auth?: boolean;
  /**
   * 是否需要路由重定向
   */
  isRedirect?: boolean;
  /**
   * 是否需要动态加载路由
   */
  isDynamic?: boolean;
  /**
   * 动态加载路由时的提示文案
   */
  loadingFallback?: string;
  /**
   * 路由组件
   */
  component: any;
  /**
   * Only organization grandmasters may open this route (new/uncommitted UX).
   */
  grandmasterOnly?: boolean;
  /**
   * 子路由
   */
  children?: RouteConfigDeclaration[];
}
let routes: RouteConfigDeclaration[] = [
  {
    path: "/test",
    component: Test,
    exact: true,
    auth: false,
  },
  {
    path: "/login",
    component: Login,
    exact: true,
    auth: false,
  },
  {
    path: "/delete",
    component: DeleteApp,
    exact: true,
    auth: false,
  },
  {
    path: "/forget",
    component: Forget,
    exact: true,
    auth: false,
  },
  {
    path: "/resetPassword",
    component: Reset,
    exact: true,
    auth: false,
  },
  {
    path: "/accept-invite",
    component: AcceptInvite,
    exact: true,
    auth: false,
  },
  {
    path: "/home",
    component: Login, //HomePage,
    exact: true,
    auth: false,
  },
  {
    path: "/privacy",
    component: PrivacyPolicyRedirect,
    exact: true,
    auth: false,
  },
  {
    path: "/terms",
    component: TermsOfUseRedirect,
    exact: true,
    auth: false,
  },
  {
    path: "/yet",
    component: Yet,
    exact: true,
    auth: false,
  },
  {
    path: "/assess",
    component: AccessIndex,
    exact: true,
    auth: false,
  },
  {
    path: "/complete",
    component: Complete,
    exact: true,
    auth: false,
  },
  {
    path: "/*",
    component: Index,
    exact: false,
    children: [
      {
        path: "/legacy-shifts/*",
        component: LegacyShifts,
        exact: false,
        children: [
          {
            path: "active",
            component: ShiftsActive,
            exact: true,
          },
          {
            path: "confirmed",
            component: ShiftsConfirmed,
            exact: true,
          },
          {
            path: "archived",
            component: ShiftsArchived,
            exact: true,
          },
          {
            path: "applications",
            component: ShiftsActive, // Placeholder, rendered via mainTab conditional in Shifts/index.tsx
            exact: true,
          },
        ],
      },
      {
        path: "/create",
        component: ShiftCreate,
        exact: true,
      },
      {
        path: "/alter/:shiftsId/:shiftsDaysId",
        component: ShiftCreate,
        exact: true,
      },
      {
        path: "/detail/:shiftsId/:shiftsDaysId",
        component: DateActive,
        exact: true,
      },
      {
        path: "/applicants/:shiftsId/:shiftsDaysId",
        component: Applicant,
        exact: true,
      },
      {
        path: "/applicant/:shiftsId/:shiftsDaysId/:userId/:ordersId",
        component: ApplicantModalRoute,
        exact: true,
      },
      {
        path: "/doctor/:shiftsId/:shiftsDaysId/:userId",
        component: Doctor,
        exact: true,
      },
      {
        path: "/social/doctor/:userId",
        component: SocialDoctorProfile,
        exact: true,
      },
      {
        path: "/doctor-information/:userId",
        component: Doctor,
        exact: true,
      },
      {
        path: "/account",
        component: Account,
        exact: true,
      },
      {
        path: "/modify",
        component: AccountEdit,
        exact: true,
      },
      {
        path: "/test",
        component: Test,
        exact: true,
      },
      {
        path: "/tools",
        component: Vault,
        exact: true,
      },
      {
        path: "/vault",
        component: Vault,
        exact: true,
      },
      {
        path: "/bank",
        component: Bank,
        exact: true,
      },
      {
        path: "/bank/internal/:userId",
        component: InternalDoctorProfile,
        exact: true,
      },
      {
        path: "/social",
        component: Social,
        exact: true,
      },
      {
        path: "/notifications",
        component: Notifications,
        exact: true,
      },
      {
        path: "/messages",
        component: MessagesPage,
        exact: true,
      },
      {
        path: "/calendar",
        component: CalendarPage,
        exact: true,
      },
      {
        path: "/dashboard",
        component: DashboardPage,
        exact: true,
      },
      {
        path: "/overview",
        component: OverviewPage,
        exact: true,
      },
      {
        path: "/roster",
        component: RosterPage,
        exact: true,
      },
      {
        path: "/staff",
        component: StaffPage,
        exact: true,
      },
      {
        path: "/organisation",
        component: OrganisationPage,
        exact: true,
      },
      {
        path: "/departments",
        component: DepartmentsPage,
        exact: true,
      },
      {
        path: "/finance",
        component: FinancePage,
        exact: true,
      },
      {
        path: "/leave",
        component: LeavePage,
        exact: true,
      },
      {
        path: "/time",
        component: TimePage,
        exact: true,
      },
      {
        path: "/reports",
        component: ReportsPage,
        exact: true,
      },
      {
        path: "/payroll",
        component: PayrollPage,
        exact: true,
      },
      {
        path: "/hr",
        component: HrPage,
        exact: true,
      },
      {
        path: "/permanent",
        component: PermanentPage,
        exact: true,
      },
      {
        path: "/hire",
        component: ShiftsV2,
        exact: true,
      },
      {
        path: "/pre-credential",
        component: PreCredentialPage,
        exact: true,
        grandmasterOnly: true,
      },
    ],
  },
];

export default routes;
